import { Dispatch, GetState } from '../../../redux/redux.types';
import { makeIsFileSelected } from './file-manager.selectors';

export const SELECTION_ACTIONS = {
  ALL_ITEMS_SELECTIONS_TOGGLE: 'SELECTION_ACTIONS.ALL_ITEMS_SELECTIONS_TOGGLE',
  ITEM_SELECTION_TOGGLE: 'SELECTION_ACTIONS.ITEM_SELECTION_TOGGLE',
  ONE_ITEM_SELECTION: 'SELECTION_ACTIONS.ONE_ITEM_SELECTION',
  ADD_ITEM_SELECTED: 'SELECTION_ACTIONS.ADD_ITEM_SELECTED',
  REMOVE_ITEM_SELECTION: 'SELECTION_ACTIONS.REMOVE_ITEM_SELECTION',
  ITEM_SELECTION_WITH_SHIFT: 'SELECTION_ACTIONS.ITEM_SELECTION_WITH_SHIFT',
};

export const selectItemWithShift = (fileId: string) => ({
  type: SELECTION_ACTIONS.ITEM_SELECTION_WITH_SHIFT,
  payload: fileId,
});

export const selectOneItem = (fileId: string) => ({
  type: SELECTION_ACTIONS.ONE_ITEM_SELECTION,
  payload: fileId,
});

const doAddFileSelection = (fileId: string) => ({
  type: SELECTION_ACTIONS.ADD_ITEM_SELECTED,
  payload: fileId,
});

export const addFileSelection = (fileId: string) => {
  const isFileSelected = makeIsFileSelected();
  const props = { fileId };
  return (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const isSelected = isFileSelected(state, props);
    if (!isSelected) {
      dispatch(doAddFileSelection(fileId));
    }
  };
};

const doRemoveFileSelection = (fileId: string) => ({
  type: SELECTION_ACTIONS.REMOVE_ITEM_SELECTION,
  payload: fileId,
});

export const removeFileSelection = (fileId: string) => {
  const isFileSelected = makeIsFileSelected();
  const props = { fileId };

  return (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const isSelected = isFileSelected(state, props);
    if (isSelected) {
      dispatch(doRemoveFileSelection(fileId));
    }
  };
};

export const toggleItemSelection = (fileId: string) => ({
  type: SELECTION_ACTIONS.ITEM_SELECTION_TOGGLE,
  payload: fileId,
});

export const toggleAllItemsSelection = (isSelectAll: boolean) => ({
  type: SELECTION_ACTIONS.ALL_ITEMS_SELECTIONS_TOGGLE,
  payload: isSelectAll,
});
